import { memo } from 'react';
import { Handle, Position, type NodeProps, type Node } from '@xyflow/react';
import { Box, Text } from '@chakra-ui/react';
import type { StageNodeData } from '../types';

type StageNodeType = Node<StageNodeData, 'stage'>;

const StageNode = ({ data, selected }: NodeProps<StageNodeType>) => {
  return (
    <Box
      bg="grayscale.fg"
      border="2px solid"
      borderColor={selected ? 'argos.fg' : 'border.muted'}
      borderRadius="md"
      px={4}
      py={3}
      minW={160}
      textAlign="center"
      boxShadow={selected ? 'md' : 'sm'}
      cursor="pointer"
      transition="border-color 0.15s"
    >
      <Handle type="target" position={Position.Left} />
      <Text fontSize="xs" color="fg.muted" mb={0.5}>
        Etapa {data.order}
      </Text>
      <Text fontSize="sm" fontWeight={600} color="fg.default">
        {data.label}
      </Text>
      <Handle type="source" position={Position.Right} />
    </Box>
  );
};

export default memo(StageNode);
